import React from "react";
import Box from "@mui/material/Box";
import { useAppSelector } from "../../../framework/customStore";
import { SectionHeader } from "../../layout/sectionHeader";
import { MonitorViewWorkShifts } from "./monitorViewWorkShifts";
import { MonitorViewSidebarProps } from "../../../models/monitorView/monitorViewTypes";
import SidebarHeader from "./sidebarHeader";
import { MonitorViewVehicle } from "./monitorViewVehicle";
import { MonitorViewOverviewSidebar } from "./monitorViewOverviewSidebar";

export const MonitorViewSidebar = ({
    fleetSummaryTotals,
    vehiclesAndEmployeesSidebarProps
}: MonitorViewSidebarProps) => {

    const {
        sidebarTitle,
        isWorkShiftView,
        isVehicleDetailView,
    } = useAppSelector((state) => state.monitorView);

    return (
        <Box width={375} height="100%" display="flex" flexDirection="column">
            <SectionHeader>
                <SidebarHeader
                    header={sidebarTitle}
                    fleetSummaryTotals={fleetSummaryTotals}
                />
            </SectionHeader>

            <Box sx={{ overflowY: "auto", paddingTop: 1 }}>
                {isWorkShiftView ? (
                    <MonitorViewWorkShifts
                        transportOrders={vehiclesAndEmployeesSidebarProps.transportOrders}
                    />
                ) : isVehicleDetailView ? (
                    <MonitorViewVehicle
                        transportOrders={vehiclesAndEmployeesSidebarProps.transportOrders}
                    />
                ) : (
                    <MonitorViewOverviewSidebar
                        {...vehiclesAndEmployeesSidebarProps}
                        fleetSummaryTotals={fleetSummaryTotals}
                    />
                )}

            </Box>
        </Box>
    );
};
